<div class="page-tickets-type">
    <div class="d-block d-md-flex justify-content-between align-items-center">
        <div class="d-flex gap-2 align-items-center m-0" *ngIf="venue && !typeTicketsSession">
            <i class="fal fa-info-circle icon-primary"></i>
            <p class="info-ticket-venue m-0">Se muestran los tipos de entradas del {{venue?.name}}</p>
        </div>
    </div>
    <div class="d-flex align-items-center"
        [class]="sessions?.length > 1 ? 'justify-content-between' : 'justify-content-end'">
        <div class="d-flex align-items-center" *ngIf="sessions?.length > 1">
            <!-- <mat-checkbox [(ngModel)]="typeTicketsSession" (ngModelChange)="changeTypeTicketsSession($event)"
                class="checkbox" color="primary" required>
            </mat-checkbox>
            <p class="text-checkbox m-0">
                Distintos precios por sesión
            </p> -->
        </div>
        <div class="btn-create m-0"
             *ngIf="useMapVenue && venue && venue?.current_version"
             (click)="openCreateTicket()">
            <i class="fal fa-plus-circle"></i>
            <p class="m-0">Añadir entrada nueva</p>
        </div>
    </div>
    <!-- Sessions view when typeTicketsSession is enabled -->
    <div *ngIf="typeTicketsSession && sessions && sessions.length > 0">
        <!-- Hierarchical session selector -->
        <div class="session-selector-container">
            <mat-form-field appearance="fill" class="select-filter-sessions">
                <mat-select placeholder="Seleccionar" [multiple]="true" [value]="selectedSessionIndices"
                    disableOptionCentering panelClass="hierarchical-select-panel">
                    <!-- All sessions option -->
                    <mat-option class="hierarchical-option level-0" (click)="toggleAllSessions($event)" [value]="null"
                        [disabled]="true">
                        <div class="d-flex align-items-center gap-2 w-100 custom-checkbox-container">
                            <div class="custom-checkbox" [class.checked]="allSelected">
                                <i class="fas fa-check check-icon" *ngIf="allSelected"></i>
                            </div>
                            <span class="option-text">Todas las sesiones</span>
                        </div>
                    </mat-option>

                    <!-- Years -->
                    <ng-container *ngFor="let yearData of hierarchicalData.years">
                        <mat-option class="hierarchical-option level-1"
                            (click)="toggleYearSelection(yearData.year, $event)" [value]="null" [disabled]="true">
                            <div class="d-flex align-items-center gap-2 w-100 custom-checkbox-container">
                                <i class="fal fa-chevron-right expand-icon"
                                    [class.expanded]="yearExpanded[yearData.year]"
                                    (click)="toggleYear(yearData.year, $event)"></i>
                                <div class="custom-checkbox" [class.checked]="isYearSelected(yearData.year)">
                                    <i class="fas fa-check check-icon" *ngIf="isYearSelected(yearData.year)"></i>
                                </div>
                                <span class="option-text">{{ yearData.year }}</span>
                            </div>
                        </mat-option>

                        <!-- Months -->
                        <ng-container *ngIf="yearExpanded[yearData.year]">
                            <ng-container *ngFor="let monthData of yearData.months">
                                <mat-option class="hierarchical-option level-2"
                                    (click)="toggleMonthSelection(monthData.monthYear, $event)" [value]="null"
                                    [disabled]="true">
                                    <div class="d-flex align-items-center gap-2 w-100 custom-checkbox-container">
                                        <i class="fal fa-chevron-right expand-icon"
                                            [class.expanded]="monthExpanded[monthData.monthYear]"
                                            (click)="toggleMonth(monthData.monthYear, $event)"></i>
                                        <div class="custom-checkbox"
                                            [class.checked]="isMonthSelected(monthData.monthYear)">
                                            <i class="fas fa-check check-icon"
                                                *ngIf="isMonthSelected(monthData.monthYear)"></i>
                                        </div>
                                        <span class="option-text">{{ monthData.monthName }}</span>
                                    </div>
                                </mat-option>

                                <!-- Sessions -->
                                <ng-container *ngIf="monthExpanded[monthData.monthYear]">
                                    <mat-option class="hierarchical-option level-3"
                                        *ngFor="let sessionData of monthData.sessions"
                                        (click)="toggleSessionSelection(sessionData.index, $event)"
                                        [value]="sessionData.index">
                                        <div class="d-flex align-items-center gap-2 w-100 custom-checkbox-container">
                                            <div class="custom-checkbox"
                                                [class.checked]="isSessionSelected(sessionData.index)">
                                                <i class="fas fa-check check-icon"
                                                    *ngIf="isSessionSelected(sessionData.index)"></i>
                                            </div>
                                            <span class="option-text">{{ getSessionDateString(sessionData.session)
                                                }}</span>
                                        </div>
                                    </mat-option>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </mat-select>
            </mat-form-field>
        </div>

        <!-- Display selected sessions -->
        <ng-container *ngFor="let sessionIndex of selectedSessionIndices">
            <div *ngIf="sessionIndex >= 0 && sessions[sessionIndex]" class="session-panel">
                <div class="session-header">
                    <div class="d-flex align-items-center gap-2" (click)="toggleSession(sessionIndex)">
                        <i class="fal"
                            [ngClass]="isSessionExpanded(sessionIndex) ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                        <span class="session-title">{{ getSessionDateString(sessions[sessionIndex]) }}</span>
                    </div>
                    <a class="link-apply-prices" *ngIf="isSessionExpanded(sessionIndex)"
                        (click)="applyPricesToAllSessions(sessionIndex); $event.stopPropagation()">
                        Aplicar estos precios al resto de tablas
                    </a>
                </div>

                <div class="session-content" *ngIf="isSessionExpanded(sessionIndex)">
                    <!-- Tickets with map -->
                    <div *ngIf="venue && venue?.current_version; else noMapTickets">
                        <div *ngIf="getSessionTickets(sessionIndex).length > 0; else noTicketsYetWithMap">
                            <div class="grid-tables-tickets">
                                <div class="table-events table-panel table-grey" *ngFor="let level of levels">
                                    <table class="mat-elevation-z28">
                                        <thead>
                                            <tr class="level-fixed-row">
                                                <th colspan="2"><b>{{level.name}}</b></th>
                                            </tr>
                                            <tr>
                                                <th>Zona/Tipo</th>
                                                <th>Precio</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let ticket of getSessionTickets(sessionIndex); let i = index">
                                                <td>
                                                    <div class="d-flex gap-2 align-items-center">
                                                        <div>
                                                            <div [matMenuTriggerFor]="actionOptions"
                                                                style="width: 20px;"
                                                                class="pointer-in d-flex justify-content-center">
                                                                <i class="icon-option fal fa-ellipsis-vertical"></i>
                                                            </div>
                                                            <mat-menu class="options-menu-control-panel"
                                                                #actionOptions="matMenu">
                                                                <button mat-menu-item class="deleteIcon"
                                                                    (click)="editTicketFromSession(sessionIndex, ticket, i)">Editar</button>
                                                                <button mat-menu-item class="deleteIcon"
                                                                    (click)="deleteTicketFromSession(sessionIndex, i)">Eliminar</button>
                                                            </mat-menu>
                                                        </div>
                                                        <span class="link-titulo">{{ticket.name}} <span
                                                                *ngIf="ticket.only_tpv_sales"
                                                                style="color: var(--color-light);">(Solo
                                                                taquilla)</span></span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="input-price">
                                                        <input type="number" min="0" placeholder="-"
                                                            [(ngModel)]="getTicketLevel(ticket, level.id).price"
                                                            (ngModelChange)="changeTicketPriceInSession(sessionIndex)"
                                                            (keydown)="preventNegative($event)"
                                                            (blur)="formatLevelPrice(ticket, level.id)">
                                                        <span>€</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <ng-template #noTicketsYetWithMap>
                            <p class="text-center m-3" style="color: var(--color-light);">No hay entradas para esta
                                sesión</p>
                        </ng-template>
                    </div>

                    <!-- Tickets without map -->
                    <ng-template #noMapTickets>
                        <div *ngIf="getSessionTickets(sessionIndex).length > 0; else noTicketsYet">
                            <div class="d-flex gap-2 justify-content-between align-items-center item-ticket-simple"
                                *ngFor="let ticket of getSessionTickets(sessionIndex); let i = index">
                                <div class="d-flex gap-2 align-items-center" [matMenuTriggerFor]="actionOptions">
                                    <i class="icon-option fal fa-ellipsis-vertical pointer-in"></i>
                                    <mat-menu class="options-menu-control-panel" #actionOptions="matMenu">
                                        <button mat-menu-item class="deleteIcon"
                                            (click)="editTicketFromSession(sessionIndex, ticket, i)">Editar</button>
                                        <button mat-menu-item class="deleteIcon"
                                            (click)="deleteTicketFromSession(sessionIndex, i)">Eliminar</button>
                                    </mat-menu>
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span class="link-titulo">{{ticket.name}} <span *ngIf="ticket.only_tpv_sales"
                                                style="color: var(--color-light);">(Solo taquilla)</span></span>
                                    </div>
                                </div>
                                <div class="input-price">
                                    <input type="number" min="0" [(ngModel)]="ticket.price" placeholder="-"
                                        (ngModelChange)="changeTicketPriceInSession(sessionIndex)"
                                        (keydown)="preventNegative($event)"
                                        (blur)="formatPrice(ticket)">
                                    <span>€</span>
                                </div>
                            </div>
                        </div>
                        <ng-template #noTicketsYet>
                            <p class="text-center m-3" style="color: var(--color-light);">No hay entradas para esta
                                sesión</p>
                        </ng-template>
                    </ng-template>
                </div>
            </div>
        </ng-container>
    </div>

    <!-- Original view when typeTicketsSession is disabled -->
    <div class="margin-table" *ngIf="!typeTicketsSession">

        <!-- Loading -->
        <div *ngIf="loadingTickets" class="container-lottie">
            <div class="loading-container">
                <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
                    containerClass="loading-box"></ng-lottie>
            </div>
        </div>

        <ng-container *ngIf="!loadingTickets">

            <!-- ── CON MAPA: tabla expandible por niveles ── -->
            <ng-container *ngIf="useMapVenue && venue?.current_version">

                <!-- Sin entradas -->
                <p class="text-center m-5 empty-tickets-msg" *ngIf="!tickets || tickets.length === 0">
                    Aún no existen entradas para este evento
                </p>

                <div class="tickets-table" *ngIf="tickets && tickets.length > 0">
                    <div class="table-header table-header-map">
                        <span class="col-name">Entrada</span>
                        <span class="col-price">Precio</span>
                        <span class="col-status">Estado</span>
                        <span class="col-status">Solo taquilla</span>
                        <span class="col-status">Permitir descuentos</span>
                        <span class="col-actions"></span>
                    </div>

                    <div class="ticket-row-wrapper"
                         *ngFor="let ticket of tickets; let i = index"
                         [class.expanded]="isExpanded(ticket.id)"
                         [class.unconfigured]="isUnconfigured(ticket)">

                        <div class="ticket-row ticket-row-map" (click)="onTicketRowClick(ticket)">
                            <div class="col-name">
                                <i class="fal fa-chevron-right chevron" [class.rotated]="isExpanded(ticket.id)"></i>
                                <span class="ticket-name">{{ ticket.name }}</span>
                                <span class="ticket-badge special" *ngIf="ticket.special_seats">Especial</span>
                                <span class="ticket-badge unconfigured-badge" *ngIf="isUnconfigured(ticket)">Sin configurar</span>
                            </div>
                            <div class="col-price">
                                <span class="price-label">{{ isUnconfigured(ticket) ? '—' : getPriceLabel(ticket) }}</span>
                            </div>
                            <div class="col-status" (click)="$event.stopPropagation()">
                                <mat-slide-toggle
                                    class="ticket-toggle"
                                    [checked]="!isUnconfigured(ticket) && ticket.active !== false"
                                    (change)="toggleTicketActive(ticket, $event)">
                                </mat-slide-toggle>
                            </div>
                            <div class="col-status" (click)="$event.stopPropagation()">
                                <mat-slide-toggle
                                    class="ticket-toggle"
                                    [checked]="ticket.only_tpv_sales === true"
                                    (change)="toggleOnlyTpvSales(ticket, $event)"
                                    [disabled]="isUnconfigured(ticket)">
                                </mat-slide-toggle>
                            </div>
                            <div class="col-status" (click)="$event.stopPropagation()">
                                <mat-slide-toggle
                                    class="ticket-toggle"
                                    [checked]="ticket.allow_discounts !== false"
                                    (change)="toggleAllowDiscounts(ticket, $event)"
                                    [disabled]="isUnconfigured(ticket)">
                                </mat-slide-toggle>
                            </div>
                            <div class="col-actions" (click)="$event.stopPropagation()">
                                <div [matMenuTriggerFor]="ticketMenuMap" class="menu-trigger" *ngIf="!ticket.base">
                                    <i class="fal fa-ellipsis-vertical"></i>
                                </div>
                                <mat-menu class="options-menu-control-panel" #ticketMenuMap="matMenu">
                                    <button mat-menu-item (click)="openCreateTicket(ticket, i)">
                                        <i class="fal fa-pen me-2"></i> Editar
                                    </button>
                                    <button mat-menu-item (click)="deleteTicket(ticket, i)" class="delete-item">
                                        <i class="fal fa-trash me-2"></i> Eliminar
                                    </button>
                                </mat-menu>
                            </div>
                        </div>

                        <div class="ticket-levels" *ngIf="isExpanded(ticket.id) && levels?.length > 0">
                            <div class="level-row" *ngFor="let level of levels"
                                 [class.level-row-restricted]="getTicketLevel(ticket, level.id)?.restricted">
                                <div class="level-color-dot" [style.background]="level.color || 'var(--color-primary)'"></div>
                                <span class="level-name">{{ level.name }}</span>
                                <div class="level-price-input"
                                     [class.opacity-disabled]="getTicketLevel(ticket, level.id)?.hidden || getTicketLevel(ticket, level.id)?.restricted">
                                    <input type="number" min="0" placeholder="—"
                                           *ngIf="!getTicketLevel(ticket, level.id)?.hidden && !getTicketLevel(ticket, level.id)?.restricted"
                                           [(ngModel)]="getTicketLevel(ticket, level.id).price"
                                           (ngModelChange)="changePrice(ticket, level.id, i)"
                                           (keydown)="preventNegative($event)"
                                           (blur)="formatLevelPrice(ticket, level.id)"
                                           (click)="$event.stopPropagation()">
                                    <span class="euro-sign" *ngIf="!getTicketLevel(ticket, level.id)?.hidden && !getTicketLevel(ticket, level.id)?.restricted">€</span>
                                    <span class="no-level-dash" *ngIf="getTicketLevel(ticket, level.id)?.hidden || getTicketLevel(ticket, level.id)?.restricted">—</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>

            <!-- ── SIN MAPA: tabla inline ── -->
            <ng-container *ngIf="!useMapVenue || !venue?.current_version">
                <ng-container *ngTemplateOutlet="divTicketsNoMap"></ng-container>
            </ng-container>
        </ng-container>
    </div>
    <ng-template #divTicketsNoMap>
        <div class="tickets-inline-table">

            <!-- Cabecera -->
            <div class="tit-header">
                <div class="tit-col tit-col--name">Nombre de la entrada</div>
                <div class="tit-col tit-col--price">Precio</div>
                <div class="tit-col tit-col--tpv">Estado</div>
                <div class="tit-col tit-col--tpv">Solo taquilla</div>
                <div class="tit-col tit-col--tpv">Permitir descuentos</div>
                <div class="tit-col tit-col--actions"></div>
            </div>

            <!-- Filas existentes -->
            <ng-container *ngFor="let ticket of tickets; let i = index">
            <div class="tit-row" [class.tit-row--invalid]="priceMissing(ticket)">
                <div class="tit-col tit-col--name">
                    <input class="tit-input" type="text" [(ngModel)]="ticket.name"
                        maxlength="50" placeholder="Nombre"
                        (blur)="saveTicketsInline()">
                </div>
                <div class="tit-col tit-col--price">
                    <div class="tit-price" [class.tit-price--error]="priceMissing(ticket)">
                        <input type="number" min="0" [(ngModel)]="ticket.price"
                            placeholder="0" (keydown)="preventNegative($event)"
                            (blur)="saveTicketsInline()">
                        <span class="tit-price-symbol">€</span>
                    </div>
                </div>
                <div class="tit-col tit-col--tpv">
                    <mat-slide-toggle class="ticket-toggle"
                        [checked]="ticket.active !== false"
                        (change)="ticket.active = $event.checked; saveTicketsInline()"></mat-slide-toggle>
                </div>
                <div class="tit-col tit-col--tpv">
                    <mat-slide-toggle class="ticket-toggle"
                        [(ngModel)]="ticket.only_tpv_sales" [ngModelOptions]="{standalone: true}"
                        (change)="saveTicketsInline()"></mat-slide-toggle>
                </div>
                <div class="tit-col tit-col--tpv">
                    <mat-slide-toggle class="ticket-toggle"
                        [checked]="ticket.allow_discounts !== false"
                        (change)="ticket.allow_discounts = $event.checked; saveTicketsInline()"></mat-slide-toggle>
                </div>
                <div class="tit-col tit-col--actions">
                    <button class="tit-del-btn" *ngIf="!ticket.base" (click)="deleteTicket(ticket, i)" matTooltip="Eliminar">
                        <i class="fal fa-trash"></i>
                    </button>
                </div>
            </div>
            <div class="tit-row-error" *ngIf="priceMissing(ticket)">
                <i class="fal fa-circle-exclamation"></i>
                <span>Añade un precio a la entrada para poder guardarla</span>
            </div>
            </ng-container>

            <!-- Fila nueva en curso -->
            <div class="tit-row tit-row--pending" *ngIf="addingTicketRow">
                <div class="tit-col tit-col--name">
                    <input #pendingNameInput class="tit-input tit-input--focus" type="text"
                        [(ngModel)]="pendingTicket.name" maxlength="50"
                        placeholder="Nombre de la entrada"
                        (keydown.enter)="confirmTicketRow()">
                </div>
                <div class="tit-col tit-col--price">
                    <div class="tit-price">
                        <input type="number" min="0" [(ngModel)]="pendingTicket.price"
                            placeholder="0" (keydown)="preventNegative($event)"
                            (keydown.enter)="confirmTicketRow()">
                        <span class="tit-price-symbol">€</span>
                    </div>
                </div>
                <div class="tit-col tit-col--tpv">
                    <mat-slide-toggle class="ticket-toggle"
                        [(ngModel)]="pendingTicket.active" [ngModelOptions]="{standalone: true}"></mat-slide-toggle>
                </div>
                <div class="tit-col tit-col--tpv">
                    <mat-slide-toggle class="ticket-toggle"
                        [(ngModel)]="pendingTicket.only_tpv_sales" [ngModelOptions]="{standalone: true}"></mat-slide-toggle>
                </div>
                <div class="tit-col tit-col--tpv">
                    <mat-slide-toggle class="ticket-toggle"
                        [(ngModel)]="pendingTicket.allow_discounts" [ngModelOptions]="{standalone: true}"></mat-slide-toggle>
                </div>
                <div class="tit-col tit-col--actions">
                    <div class="tit-pending-actions">
                        <button class="tit-ok-btn" (click)="confirmTicketRow()"
                            [disabled]="!pendingTicket.name?.trim()" matTooltip="Guardar (Enter)">
                            <i class="fal fa-check"></i>
                        </button>
                        <button class="tit-cancel-btn" (click)="cancelTicketRow()" matTooltip="Cancelar">
                            <i class="fal fa-xmark"></i>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Estado vacío -->
            <div class="tit-empty" *ngIf="(!tickets || tickets.length === 0) && !addingTicketRow">
                <i class="fal fa-ticket tit-empty-icon"></i>
                <span>Aún no hay entradas. Añade la primera.</span>
            </div>

            <!-- Botón añadir fila -->
            <div class="tit-add-btn" (click)="startAddTicketRow()" *ngIf="!addingTicketRow">
                <i class="fal fa-plus"></i>
                <span>Añadir entrada</span>
            </div>
        </div>
    </ng-template>
    <ng-template #divNotTickets>
        <p class="text-center m-5">Aún no existen entradas para este evento</p>
    </ng-template>

</div>
